@if (hasAlertConfigCreatePermission()) {
  <div class="alerts-page-create-alert-button-wrapper">
    <button class="btn-primary alerts-page-create-alert-button"
      data-cy="alerts-page-create-alert-button"
      (click)="openCreateAlertConfigForm(null)">
      <span class="iwp-icon-gen_add alerts-page-create-alert-button-icon"></span>
      <span data-cy="alerts-page-create-alert-button-text">Create alert</span>
    </button>
  </div>
}

<div class="alert-content-wrapper">
  @if (state.isAlertsFormOpen) {
    <app-alerts-form
      [id]="$safeNavigationMigration(state?.editAlertConfig?.code)"
      [editAlertConfig]="state.editAlertConfig"
      [isViewMode]="state.openAlertsFormInViewMode"
      [triggerLocalSpinner]="triggerAlertsFormSpinner"
      [hasEditPermission]="state.hasEditPermission"
      (lineToAnimated)="lineToAnimated($event)"
      (closeAlertCreateNewForm)="closeForm($event)"
    (deleteAlert)="deleteAlertConfigModal($event, true)"></app-alerts-form>
  }

  <div #alertsTable class="alerts-page-table" [ngClass]="{'alerts-page-table-open-create': state.isAlertsFormOpen}">

    <div class="alerts-page-title" data-cy="alerts-page-title">Alerts list</div>

    <app-table (clearAllFiltersClick)="clearAllFilters()"
      (sortedBy)="sortedByChange($event)"
      [reduceTableColumns]="reduceTableSize"
      [tableData]="state.tableData"
      [excludedColumnsOnResize]="alertsConfig.excludeColumnsOnResize"
      [hasClearAllButton]="hasClearAllButton"
      [initiallySortedBy]="search.initiallySortedBy"
      [hasBackgroundBlur]="state.isAlertsFormOpen"
      tableName="alerts list">
    </app-table>

    @if (hasPagination()) {
      <app-pagination (pageNumber)="changePage($event)"
        [collectionSize]="search.totalResults"
        [pageSize]="search.pageSize"
        [page]="search.pageNumber"
        class="alerts-table-pagination"
        data-cy="alerts-list-pagination">
      </app-pagination>
    }

    @if (spinnerObservable | async) {
      <div class="spinner-container alert-table-spinner">
        <app-loading-spinner class="center-spinner"></app-loading-spinner>
      </div>
    }

    <ng-template #alertNameFilterTemplate>
      <app-simple-filter #alertNameFilter
        (filterEvent)="filterChange($event)"
        [filterName]="AlertsColumnEnum.NAME"
        [placeHolder]="'Search by name'"
      formatWithoutCode="true"></app-simple-filter>
    </ng-template>

    <ng-template #alertContentFilterTemplate>
      <app-simple-filter #alertContentFilter
        (filterEvent)="filterChange($event)"
        [filterName]="AlertsColumnEnum.DESCRIPTION"
        [placeHolder]="'Search by content'"
      formatWithoutCode="true"></app-simple-filter>
    </ng-template>


    <ng-template #startsOnFilterTemplate>
      <app-date-filter #startsOnFilter
        (filterEvent)="filterChange($event)"
        [dateDisplayedInUtc]="false"
        [filterName]="AlertsColumnEnum.STARTS_ON"
      [hasEmptyOption]="true"></app-date-filter>
    </ng-template>

    <ng-template #endsOnFilterTemplate>
      <app-date-filter #endsOnFilter
        (filterEvent)="filterChange($event)"
        [dateDisplayedInUtc]="false"
        [filterName]="AlertsColumnEnum.ENDS_ON"
      [hasEmptyOption]="true"></app-date-filter>
    </ng-template>

    <ng-template #createdByFilterTemplate>
      <app-input-and-code-filter #createdByFilter
        (filterEvent)="filterChange($event)"
        [filterName]="AlertsColumnEnum.CREATED_BY"
        placeHolder="Search by username"
      formatWithoutCode="true"></app-input-and-code-filter>
    </ng-template>

    <ng-template #createdOnFilterTemplate>
      <app-date-filter #createdOnFilter
        (filterEvent)="filterChange($event)"
        [dateDisplayedInUtc]="true"
      [filterName]="AlertsColumnEnum.CREATED_ON"></app-date-filter>
    </ng-template>

    <ng-template #updatedByFilterTemplate>
      <app-input-and-code-filter #updatedByFilter
        (filterEvent)="filterChange($event)"
        [filterName]="AlertsColumnEnum.UPDATED_BY"
        placeHolder="Search by username"
      formatWithoutCode="true"></app-input-and-code-filter>
    </ng-template>

    <ng-template #updatedOnFilterTemplate>
      <app-date-filter #updatedOnFilter
        (filterEvent)="filterChange($event)"
        [dateDisplayedInUtc]="true"
      [filterName]="AlertsColumnEnum.UPDATED_ON"></app-date-filter>
    </ng-template>

    <ng-template #statusFilterTemplate>
      <app-code-filter #statusFilter
        (filterEvent)="filterChange($event)"
        [codes]="statusFilterCodes"
        [filterName]="AlertsColumnEnum.ACTIVE"
        [formatWithoutCode]="true"
      disableInputFilter="true"></app-code-filter>
    </ng-template>
  </div>
</div>